import React from 'react';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';

export type SearchInputPros = {
  search: string;
  setSearch: (value: string) => void;
  label: TextFieldProps['label'];
  helperText?: TextFieldProps['helperText'];
};

export const SearchInput = ({ search, setSearch, label, helperText }: SearchInputPros) => (
  <TextField
    onChange={(event): void => setSearch(event.target.value)}
    value={search}
    label={label}
    helperText={helperText}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          {search?.length > 0 && (
            <IconButton
              aria-label="Clear input"
              onClick={(): void => setSearch('')}
              edge="end"
              style={{ marginRight: 10 }}
            >
              <ClearIcon />
            </IconButton>
          )}
          <SearchIcon />
        </InputAdornment>
      ),
    }}
    style={{ width: '100%' }}
  />
);
